import type { WalletStake } from '../../api/walletStakes'

export default function UnstakeConfirmModal({
  stake,
  open,
  busy,
  onClose,
  onConfirm,
}: {
  stake: WalletStake | null
  open: boolean
  busy?: boolean
  onClose: () => void
  onConfirm: () => Promise<void>
}) {
  if (!open || !stake) return null
  return (
    <div className="fixed inset-0 z-50">
      <div className="absolute inset-0 bg-black/60" onClick={onClose} />
      <div className="absolute inset-x-0 bottom-0 md:inset-0 md:flex md:items-center md:justify-center">
        <div className="md:w-[500px] w-full bg-neutral-950 border-t md:border border-white/10 rounded-t-2xl md:rounded-2xl p-4">
          <div className="text-white font-extrabold text-lg">Unstake PIXE</div>
          <div className="mt-2 text-sm text-white/75">
            Return <span className="font-semibold text-white">{Number(stake.amount_pixe).toLocaleString()} PIXE</span> to your available balance?
          </div>
          <div className="mt-4 flex justify-end gap-2">
            <button onClick={onClose} disabled={busy} className="px-4 py-2 rounded-lg border border-white/15 text-white/90 hover:bg-white/10 disabled:opacity-60">Cancel</button>
            <button
              onClick={onConfirm}
              disabled={busy}
              className="px-4 py-2 rounded-lg bg-emerald-600 hover:bg-emerald-500 text-white font-semibold disabled:opacity-60"
            >
              {busy ? 'Unstaking...' : 'Confirm Unstake'}
            </button>
          </div>
        </div>
      </div>
    </div>
  )
}
